import { alpha, Theme } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            '& .MuiDrawer-paperAnchorLeft': {
              boxShadow: `0.5rem 1.5rem 1.5rem 0.75rem ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`
            },
            '& .MuiDrawer-paperAnchorRight': {
              boxShadow: `-0.5rem 1.5rem 1.5rem 0.75remx ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`
            }
          }
        }
      }
    }
  };
}
